import React, { useEffect, useState } from 'react';
import Header from "../../components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { getPriceSagaAction, removePriceSagaAction, sortSagaAction } from "../../redux/sagaActions";
import PriceHeader from "../../components/PagesHeaders/PriceHeader/PriceHeader";
import PriceForm from "../../components/PriceForm/PriceForm";
import { priceFormAction } from "../../redux/rootReducer";
import { ReactSortable } from "react-sortablejs";

const Price = () => {
    const dispatch = useDispatch();
    const price = useSelector(state => state.price);
    const currentEstablishment = useSelector(state => state.currentEstablishment);

    const [currentType, setCurrentType] = useState(null);
    // Массив с типами тренировок
    const [types, setTypes] = useState({});

    const [list, setList] = useState([]);

    // Наличие отображения вкладок
    const [tabs, setTabs] = useState(true);
    // Фильтрованный прайс
    const [priceComputed, setPriceComputed] = useState([]);

    // Смена позиций
    const changePositions = ({ oldInd, newInd }) => {
        // Копируем начальный массив
        let copy = [...priceComputed];

        let cut = copy.splice(oldInd, 1)[0];
        copy.splice(newInd, 0, cut);

        dispatch(sortSagaAction({
            table: 'price',
            new_order: JSON.stringify(copy.map(elem => elem.id))
        }));

        setList([]);
    };

    useEffect(() => {
        // Объект для типов тренировок
        let typesTmp = {};

        price.forEach(elem => {
            // Сохраняем текущий тип тренировки, если его нет в typesTmp
            if (typesTmp[elem.type.id] === undefined) {
                typesTmp[elem.type.id] = { id: elem.type.id, name: elem.type.name };
            }
        });
        // Сохраняем новое состояние вкладок
        setTypes(typesTmp);

        if (!currentType) {
            setCurrentType(Object.keys(typesTmp)[0]);
        }

    }, [price]);

    useEffect(() => {
        if (tabs) {
            setPriceComputed([...price].filter(el => el.type.id === currentType));
        }
        else {
            setPriceComputed([...price]);
        }
    }, [currentType, tabs, price]);

    useEffect(() => {

        if (!currentEstablishment) return;

        // Получение цен
        dispatch(getPriceSagaAction());
    }, [currentEstablishment]);

    return (
        <>
            <Header component={
                <PriceHeader
                    currentType={ currentType }
                    setCurrentType={ setCurrentType }
                    types={ tabs ? types : {} }
                    tabs={ tabs }
                    setTabs={ setTabs }
                />
            } />
            <PriceForm/>
            <div className="page">
                <div className="settings">
                    <ReactSortable
                        list={ list }
                        setList={ setList }
                        handle={ '.control--move' }
                        onEnd={ event => changePositions({ oldInd: event.oldIndex, newInd: event.newIndex }) }
                    >
                        {
                            priceComputed.map(elem => {
                                return (
                                    <div className="setting" key={ elem.id }>
                                        <div className="controls">
                                            <i className="control control--edit"
                                               onClick={ () => dispatch(priceFormAction({
                                                   open: true,
                                                   id: elem.id,
                                                   name: elem.name,
                                                   cost: elem.cost,
                                                   sale: elem.sale,
                                                   description: elem.description,
                                                   establishments: elem.establishment,
                                                   type: elem.type,
                                                   time_constraint: elem.time_constraint,
                                                   coach: elem.coach,
                                                   duration: elem.duration,
                                                   times: elem.times,
                                                   with_coach: elem.with_coach,
                                                   one_time: elem.one_time,
                                                   online_payment: elem.online_payment,
                                                   renewal_discount: elem.renewal_discount,
                                                   hide_in_app: elem.hide_in_app,
                                                   first_time_pay: elem.first_time_pay
                                               })) }
                                            />
                                            { !tabs && <i className="control control--move" /> }
                                            <i className="control control--remove"
                                               onClick={ () => {

                                                   if (window.confirm('Вы действительно хотите удалить выбранное занятие?')) {
                                                       dispatch(removePriceSagaAction({
                                                           price_id: elem.id
                                                       }));
                                                   }
                                               } }
                                            />
                                        </div>
                                        <div className="setting__caption">{ `${ elem.name }, ${ elem.sale || elem.cost } руб.` }</div>
                                        <div className="setting__info-wrapper">
                                            { elem.online_payment === '1' && <div className="setting__info setting__info--online">онлайн</div> }
                                            { elem.sale && <div className="setting__info setting__info--sale">скидка</div> }
                                            { elem.renewal_discount !== '0' && <div className="setting__info setting__info--renewal">продление</div> }
                                            { elem.hide_in_app === '1' && <div className="setting__info setting__info--hide">скрыт</div> }
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </ReactSortable>
                </div>
            </div>
        </>
    );
};

export default Price;